import IPDatePicker from './IPDatePicker'

export default IPDatePicker
